/**
 * EmailService — sends transactional emails via the backend (webhook-server + Resend).
 * API key is stored ONLY on the server.
 */

const EMAIL_SERVER = '/email'; // nginx proxies to webhook-server

/** Send welcome email after registration. Fire-and-forget. */
export async function sendWelcomeEmail(
  email: string,
  nickname: string,
): Promise<void> {
  try {
    await fetch(`${EMAIL_SERVER}/welcome`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, nickname }),
    });
  } catch (err) {
    // Non-critical — don't block registration flow
    console.error('Failed to send welcome email:', err);
  }
}
